var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"designer-v2-page-main"},[_c('DesignerV2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }